/*
RISK-SORT
Choose sorting order for risks or populations : by residual risk, size or name
*/

import CycleSortButton from "@/components/CycleSortButton"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { Sort } from "@/core/factory/types"
import { faSortAlphaAsc, faSortAmountDown, faSortNumericDesc } from "@fortawesome/free-solid-svg-icons"
import { useEffect } from "react"
import { t } from "i18next"

interface Props {
  store: { selectors: { sort: (state: any) => Sort }; actions: { sort: (sort: Sort) => any } }
  keys: { risk: string; size: string; name: string } //Champs de tri des elements du store
}

export default function RiskSort({ store, keys }: Props) {
  const dispatch = useAppDispatch()
  const sort = useAppSelector(store.selectors.sort)

  const sortItems = [
    {
      key: keys.risk,
      name: t("risk_item_rr"),
      asc: false,
      keySecondary: keys.size,
      ascSecondary: false,
      icon: faSortAmountDown
    },
    {
      key: keys.size,
      name: t("units_size"),
      asc: false,
      keySecondary: keys.risk,
      ascSecondary: false,
      icon: faSortNumericDesc
    },
    {
      key: keys.name,
      name: "Nom",
      asc: true,
      icon: faSortAlphaAsc
    }
  ].map((item) => ({
    ...item,
    name: `Trier par ${item.name.toLowerCase()}`
  }))

  useEffect(() => {
    if (!sortItems.some((item) => item.key === sort.key)) {
      dispatch(store.actions.sort(sortItems[0]))
    }
  }, [])

  return (
    <div className="flex items-center shrink-0 ml-[10px]">
      <CycleSortButton items={sortItems} activeKey={sort.key} onChange={(item) => dispatch(store.actions.sort(item))} />
    </div>
  )
}
